<template>
  <div
    class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-flex ts-space-x-3"
  >
    <p class="ts-mb-0">
      {{ $t('wholesale.fxKhrRate') }} :
      <span class="ts-font-extrabold ts-text-red-600">{{ khrRate }}</span>
    </p>
    <p class="ts-mb-0">
      {{ $t('wholesale.fxthbRate') }}:
      <span class="ts-font-extrabold ts-text-red-600">{{ thbRate }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'exchangeRate',
  props: ['value'],
  data() {
    return {
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    khrRate() {
      let foundFx = this.$store.state.wholesale.operation.exchangeRate.find(
        e => e.to_currency == 'KHR'
      )
      if (foundFx) {
        return (this.model.fx_rate_khr = parseFloat(foundFx.fx_rate))
      }
      return 0
    },
    thbRate() {
      let foundFx = this.$store.state.wholesale.operation.exchangeRate.find(
        e => e.to_currency == 'THB'
      )
      if (foundFx) {
        return (this.model.fx_rate_thb = parseFloat(foundFx.fx_rate))
      }
      return 0
    }
  }
}
</script>
